import type { ReactNode } from 'react';

import { CostAccessView } from '~/features/cost-estimate/components/cost-access-gate';

import { useCatalogCostAccess } from '../hooks/use-run-ledger';

/** Gate for catalog-service's Cost approvals page: its own approver-status decides. */
export function CatalogCostAccessGate({ children }: { children: ReactNode }) {
  return <CostAccessView access={useCatalogCostAccess()}>{children}</CostAccessView>;
}
